/**
 * Ponemos el foco en el campo de email cuando pinchas en identificarse
 */
window.focusOnNavbarLoginFormInputEmail = function () {
    setTimeout(function () {
        $("#navbarLoginFormInputEmail").focus();
    }, 80);
};

/**
 * Aplicamos que si pulsas el intro al rellenar la contraseña se haga la llamada al login
 */
window.submitNavbarLoginForm = function (event) {
    if (event.which == 13) {
        $("#navbarLoginFormButtonSubmit").click();
    }
};

/**
 * Send the navbar login form data. When layout size >= lg.
 */
window.doNavbarLogin = function () {
    $("#navbarLoginFormError").hide();
    if (!$('#navbarLoginForm')[0].checkValidity()) {
        $('<input type="submit">')
            .hide()
            .appendTo("#navbarLoginForm")
            .click()
            .remove();
    } else {
        var formData = new FormData();
        formData.append('email', $('#navbarLoginFormInputEmail').val());
        formData.append('password', $('#navbarLoginFormInputPassword').val());
        formData.append("_token", _token);

        $.ajax({
            url:         urlLoginAuthenticate,
            type:        "POST",
            data:        formData,
            processData: false,
            contentType: false,
            beforeSend:  function () {
                $("#navbarLoginFormButtonSubmit").prop("disabled", true);
                $("#navbarLoginFormButtonSubmit").html(`<i class="fas fa-spinner fa-spin mr-1"></i> ${trans("Processing..")}`);
            },
        })
         .done(function (response) {
             if (response.result) {
                 // Si el usuario autenticado es un proveedor, lo mandamos a la home de proveedor
                 if (response.role === 'supplier') {
                     window.location.replace(urlSupplierHome);
                 } else {
                     // Si el usuario se encuentra iniciando sesión desde la vista de login, redirigimos a la página de inicio
                     if (window.location.pathname.indexOf("login") !== -1) {
                         window.location.replace(urlHome);
                     } else {
                         // Si el cliente se encuentra en cualquier otra página se hace una recarga completa
                         window.location.reload();
                         // Si el cliente se encuentra en cualquier otra página se cambian los datos del navbar user info
                         // changeNavbarLoginFormToUserInfo(data.user.nombre);
                     }
                 }
             } else {
                 $("#navbarLoginFormError")
                     .show()
                     .find("span")
                     .html(typeof response.validationErrors !== "undefined" && response.validationErrors.length > 0 ?
                           response.validationErrors.join(`<br/>`) :
                           response.message);
             }
         })
         .always(function () {
             $("#navbarLoginFormButtonSubmit").prop("disabled", false);
             $("#navbarLoginFormButtonSubmit").html(
                 `<i class="fas fa-sign-in-alt"></i> ${trans("Login")}`
             );
         });
    }
};

/**
 * Cierra la sesión del usuario
 */
window.doLogout = function () {
    $.ajax({
        url:      urlLogout,
        type:     "POST",
        data:     {},
        dataType: "json",
    })
     .done(function (response) {
         if (response.result) {
             // Vaciamos el carrito de sessionStorage
             sessionStorage.removeItem('cart');
             // Vaciamos el carrito de sessionStorage
             sessionStorage.removeItem("dropshippingCart");
             window.location.reload();
         } else {
             pNotifyError(
                 typeof response.validationErrors !== "undefined" &&
                 response.validationErrors.length > 0
                 ? response.validationErrors.join(`<br/>`)
                 : response.message
             );
         }
     });
};

// window.changeNavbarLoginFormToUserInfo = function (name) {
//     name = name.indexOf(" ") != -1 ? name.substr(0, name.indexOf(" ")) : name;
//     name = name.toLowerCase().replace(/\b[a-z]/g, function (letter) {
//         return letter.toUpperCase();
//     });
//     $("#navbarCustomer").text(name);
//     $("#navbarLoginFormDropdown").find("i").toogleClass("fa-sign-in-alt fa-user");
// };